module.exports = __webpack_public_path__ + "static/MT_Process-05.444d8c3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-icons/MT_Process-05.png
// module id = 1502
// module chunks = 214286880276331